import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  ElementRef,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'nz-searchbar-net',
  preserveWhitespaces: false,
  templateUrl: './nz-searchbar-net.component.html',
  styles: [`
    .wrap {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .searchBtn {
      cursor: pointer;
      color: #C5CED8;
      font-size: 18.4px;
      transition: all 300ms;
    }

    .searchBtn_search {
      color: rgba(0,0,0,.65);
      transform: translateX(-220px) scale(0.8);
    }

    .searchBtn_searchEnd {
      color: rgba(0,0,0,.65);
      transform: translateX(-30px) scale(0.8);
    }

    .searchBar_init {
      width: 0;
      overflow: hidden;
      background: transparent;
      border-radius: 100px;
      transition: all 300ms;
    }

    .searchBar_search, .searchBar_search input {
      width: 227px;
      height: 30px;
    }

    input:hover, input:focus,input{
      border: none;
    }
  `]
})
export class NzSearchbarNetComponent implements OnInit, OnChanges {
  keywords = '';
  isSearch = false;
  maxlength = 20;
  @Input('alwaysExpand') alwaysExp: boolean = false;
  @Input('background') background: string = '#ffffff';
  @Input('color') color: string = 'gray';
  @Input('iconStart') iconStart: boolean = true;
  @Output('search') searching: EventEmitter<any> = new EventEmitter();

  constructor(public el: ElementRef) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.alwaysExp && changes.alwaysExp.currentValue){
      this.isSearch = true;
    }
  }

  clickEvent(): void  {
    if(this.isSearch && this.keywords.trim().length > 0){
      this.search();
    } else if(!this.alwaysExp) {
      this.isSearch = !this.isSearch;
      this.el.nativeElement.querySelector('input').focus();
    }
  }

  closeSearchBar(): void  {
    if(!this.alwaysExp){
      this.keywords = '';
      this.isSearch = false;
    }
  }

  search(): void  {
    if(this.keywords.trim().length > 0){
      this.searching.emit(this.keywords);
    }
  }

}
